export default __webpack_public_path__ + "media/366e03055c465bcae868f37916ac12ee74c0429184e15ab8e13d123f61805f2d.svg";